import { useState } from "react";
import { JobWizardStep1 } from "./JobWizardStep1";
import { JobWizardStep2 } from "./JobWizardStep2";
import { JobWizardStep3 } from "./JobWizardStep3";
import { JobWizardStep4 } from "./JobWizardStep4";
import { JobWizardStep5 } from "./JobWizardStep5";
import { JobLibraryService, SavedJobDescription as LibrarySavedJob } from "@/services/jobLibraryService";

interface JobAnalysisData {
  companyName: string;
  jobTitle: string;
  companyMission: string;
  responsibilities: string[];
  requirements: string[];
  skills: string[];
}

interface JobWizardTabsProps {
  onClose: () => void;
  onSave: (jobDescription: LibrarySavedJob) => void;
}

export function JobWizardTabs({ onClose, onSave }: JobWizardTabsProps) {
  const [currentStep, setCurrentStep] = useState(1);
  const [analysisData, setAnalysisData] = useState<JobAnalysisData | null>(null);
  const [selectedResponsibilities, setSelectedResponsibilities] = useState<string[]>([]);
  const [selectedRequirements, setSelectedRequirements] = useState<string[]>([]);
  const [selectedSkills, setSelectedSkills] = useState<string[]>([]);

  const handleAnalysisComplete = (data: JobAnalysisData) => {
    setAnalysisData(data);
    setSelectedResponsibilities([...data.responsibilities]);
    setSelectedRequirements([...data.requirements]);
    setSelectedSkills([...data.skills]);
    setCurrentStep(2);
  };

  const handleResponsibilitiesComplete = (selected: string[]) => {
    setSelectedResponsibilities(selected);
    setCurrentStep(3);
  };

  const handleRequirementsComplete = (selected: string[]) => {
    setSelectedRequirements(selected);
    setCurrentStep(4);
  };

  const handleSkillsComplete = (selected: string[]) => {
    setSelectedSkills(selected);
    setCurrentStep(5);
  };

  const handleBack = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleSave = async (jobData: any) => {
    try {
      const savedJob = await JobLibraryService.saveJob(jobData);
      onSave(savedJob);
    } catch (error) {
      console.error('Error saving job:', error);
    }
  };

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 1:
        return <JobWizardStep1 onNext={handleAnalysisComplete} onClose={onClose} />;
      case 2:
        return (
          <JobWizardStep2
            onNext={handleResponsibilitiesComplete}
            onBack={handleBack}
            responsibilities={analysisData?.responsibilities || []}
          />
        );
      case 3:
        return (
          <JobWizardStep3
            onNext={handleRequirementsComplete}
            onBack={handleBack}
            requirements={analysisData?.requirements || []}
          />
        );
      case 4:
        return (
          <JobWizardStep4
            onNext={handleSkillsComplete}
            onBack={handleBack}
            skills={analysisData?.skills || []}
          />
        );
      case 5:
        return (
          <JobWizardStep5
            onSave={handleSave}
            onBack={handleBack}
            analysisData={analysisData}
            selectedResponsibilities={selectedResponsibilities}
            selectedRequirements={selectedRequirements}
            selectedSkills={selectedSkills}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div>
      {renderCurrentStep()}
    </div>
  );
}